export const gamelobby_pathname = `/[gameRoom]`;
export const oldgames_page = `/oldgames/[gameRoom]`;
export const old_game_pathname = `/oldgames/[gameRoom]/[ppOldGameId]`;
export const old_game_stack_pathname = `/oldgames/[gameRoom]/[ppOldGameId]/[paper_stack_name]`;
